import { AddPlus10Control } from "../utils/AddPlus10Control";
import { AddSpacingControl } from "../utils/AddSpacingControl";
import { AddStaticText } from "../utils/AddStaticText";
import { appstr } from "../utils/appstr";
import { Div2Floor } from "../utils/Div2Floor";
import {
  enumDividerDirection,
  enumPanelBorderStyle,
  enumSpacingCtrlName,
  enumSpacingDiagram,
  kDenseMargins,
  kDenseMarginsStr,
  kIndent,
  kManualMargins,
  kManualMarginsStr,
  kMaxVSpacing,
  kNumSpacingCtrls,
  kSIHeight,
  kSmallSAButtonHeight,
  kSpacing,
  kSpacingAdjElementType,
  kSpacingAdjWidth,
  kSpacingControlH,
  kSpacingDraggerH,
  kSpacingHeaderH,
  kStandardMargins,
  kStandardMarginsStr,
  kVertBoxSpacing
} from "../constants";
import { GetDefaultManualSpacing } from "../utils/GetDefaultManualSpacing";
import { PAddZoomControl } from "../utils/PAddZoomControl";
import { QDivider } from "./QDivider";
import { QInputSpacingDialog } from "./QInputSpacingDialog";
import { QPanel } from "./QPanel";
import { QPanelDragger } from "./QPanelDragger";
import { QPoint } from "./QPoint";
import { QSARightClick } from "./QSARightClick";
import { QSpacingControl } from "./QSpacingControl";
import { QSpacingDiagram } from "./QSpacingDiagram";
import { QSpacingModeButton } from "./QSpacingModeButton";
import { QSpacingText } from "./QSpacingText";
import { AddStdButton } from "../utils/AddStdButton";

export class QSpacingAdjuster extends QPanel {
  constructor() {
    super();
    this.fWSMgr = null;
    this.fAdjCtrls = null;
    this.fFastPlus = null;

    this.fAdder = 1;

    this.fSpacingMode = null;
    this.fCurManualVals = null;
    this.fManualMargins = null;
    this.fRightClickCtrl = null;
  }

  InitSpacingAdjuster(wsMgr, spacingMode, startVals) {
    this.fWSMgr = wsMgr;
    this.fSpacingMode = spacingMode;
    this.fCurManualVals = startVals;
    this.fUIColors = wsMgr.GetUIColors();
    this.fTextColor = this.fUIColors.GetHeaderTextColor();

    this.SetTargetPanelRenderState(true);
    this.SetModalOn(true);
    this.SetOutsideClickDismissOn(true);
    this.SetFillColor(this.fUIColors.GetSecondaryPanelFillColor());
    this.SetShadowOn(true);
    this.SetBorderStyle(enumPanelBorderStyle.singleBorder);
    this.SetResizeBehavior(false, false, true, false);

    this.ChangeMode();
  }

  //var kSmallSAButtonWidth = kSpacingAdjWidth - 4;
  SetTargetPanelRenderState(doRender) {
    var wsMgr = this.fWSMgr;
    var targetPanel = wsMgr.fCanvasPanel;
    targetPanel.fRenderBoxSpacing = doRender;
  }

  PostStandardResize() {
    this.GetPanelOnScreen();
  }

  AddModeButton(xPos, yPos, spacingMode, selected, theCmd) {
    var modeButton = new QSpacingModeButton();
    modeButton.fTextColor = this.fTextColor;
    modeButton.PositionElement(xPos, yPos);
    modeButton.SizeElement(kSpacingAdjWidth - 4, kSmallSAButtonHeight);
    modeButton.SetCmdCode(theCmd);
    modeButton.SetMode(spacingMode);

    if (selected) {
      modeButton.SetIsToggleButton(true);
      modeButton.SetToggleState(true);
    }
    this.PushElement(modeButton);
  }

  AddModeButtons() {
    var pd = new QPanelDragger();
    pd.InitPanelDragger(this);
    pd.PositionElement(0, 0);
    pd.SizeElement(kSpacingAdjWidth, kSpacingDraggerH);
    this.PushElement(pd);

    var yPos = kIndent;

    var helpButton = this.AddHelpButton("boxspacing_help", true);
    helpButton.AutoPosition();

    AddStaticText(this, 6, yPos, appstr("spacingmode"), true, this.fTextColor);
    yPos += kSpacingHeaderH;
    this.AddModeButton(
      2,
      yPos,
      appstr(kStandardMarginsStr),
      this.fSpacingMode == kStandardMargins,
      "automaticspacing"
    );
    yPos = kSmallSAButtonHeight + 2 + 2 + kSpacingDraggerH + kSpacingHeaderH;
    this.AddModeButton(
      2,
      yPos,
      appstr(kDenseMarginsStr),
      this.fSpacingMode == kDenseMargins,
      "densespacing"
    );
    yPos = 2 * (kSmallSAButtonHeight + 2) + 2 + kSpacingDraggerH + kSpacingHeaderH;
    this.fManualMargins = this.AddModeButton(
      2,
      yPos,
      appstr(kManualMarginsStr),
      this.fSpacingMode == kManualMargins,
      "manualspacing"
    );
  }

  AddSpacingGroup(
    diagramType,
    panelWidth,
    baseY,
    controlNames,
    curValues,
    spacingControlH,
    spacingControlW,
    spacingType,
    label,
    reset0
  ) {
    var label1 = AddStaticText(this, 6, baseY, appstr(label), true, this.fTextColor);
    baseY = baseY + label1.GetHeight() + 6;

    var d1 = new QSpacingDiagram();
    d1.fTextColor = this.fTextColor;
    var diagramW = d1.CalcWidth();
    var diagramH = d1.CalcHeight(diagramType);

    var dX = Div2Floor(panelWidth - diagramW);
    var dY = baseY + spacingControlH;
    var mSpacing = diagramType == enumSpacingDiagram.mgrspacing;
    if (mSpacing) dY = baseY;

    d1.InitSpacingDiagram(diagramType);
    d1.PositionElement(dX, dY);
    this.PushElement(d1);
    var x1, y1;

    var n = controlNames.length;
    var j = 0;

    for (var i = 0; i < n; i++) {
      var cName = controlNames[i]; // enumSpacingCtrlName[i];
      var minusCmd = cName + "_" + "minus";
      var plusCmd = cName + "_" + "plus";
      var resetCmd = cName + "_" + "reset";
      var enterCmd = cName + "_" + "enter";

      if (reset0) resetCmd = resetCmd + "0";

      if (!mSpacing) {
        switch (i) {
          case 0:
            x1 = d1.GetLeft(spacingControlW);
            y1 = d1.GetMiddleY(spacingControlH);
            break;
          case 1:
            x1 = d1.GetRight();
            y1 = d1.GetMiddleY(spacingControlH);
            break;
          case 2:
            x1 = d1.GetMiddleX(spacingControlW);
            y1 = d1.GetTop(spacingControlH); // +1;
            break;
          case 3:
            x1 = d1.GetMiddleX(spacingControlW);
            y1 = d1.GetBottom(); //+4;
            break;
        }
      } else {
        switch (i) {
          case 0:
            x1 = d1.GetRight();
            y1 = d1.GetBottomY2();
            break;
          case 1:
            x1 = d1.GetRight();
            y1 = d1.GetBottomY1();
            break;
        }
      }

      var spacingCtrl = this.AddSpacingControl(
        x1,
        y1 + 2,
        curValues[i],
        minusCmd,
        plusCmd,
        spacingType,
        resetCmd,
        enterCmd
      );
      this.fAdjCtrls.push(spacingCtrl);
    }
  }

  //var gShowSpacing = true;
  ChangeMode() {
    this.RemoveAllElements();

    var margin = 4;
    var numCtrls = kNumSpacingCtrls;
    var plus10H = 24;

    var panelWidth = kSpacingAdjWidth;
    var fullPanelHeight = 440 + kSpacingDraggerH + kSpacingHeaderH; // 440
    var minPanelHeight = 3 * (kSmallSAButtonHeight + 2) + 2 + kSpacingDraggerH + kSpacingHeaderH;
    var panelHeight = minPanelHeight;
    if (this.fSpacingMode == kManualMargins) panelHeight = fullPanelHeight; //numCtrls*ctrlSpacing+margin*2+plus10H;
    this.SizePanel(panelWidth, panelHeight);

    this.AddModeButtons();

    if (this.fSpacingMode != kManualMargins) return;

    var yLoc = minPanelHeight + 4;
    var xLoc = margin;

    this.fAdjCtrls = new Array();
    var by = minPanelHeight + 8;

    var spacingControlW = 70;

    var aDivider = new QDivider();
    aDivider.InitDivider(enumDividerDirection.horzDivider, 4, false);
    aDivider.PositionElement(0, yLoc);
    aDivider.SizeElement(panelWidth, 3);
    aDivider.SetEtchState(true);
    this.PushElement(aDivider);

    var controlNames = enumSpacingCtrlName.slice(0, 4);
    var curValues = this.fCurManualVals.slice(0, 4);
    this.AddSpacingGroup(
      enumSpacingDiagram.margin,
      panelWidth,
      by,
      controlNames,
      curValues,
      kSpacingControlH,
      spacingControlW,
      "margin",
      "adjboxmarg",
      false
    );
    by = by + 120;
    controlNames = enumSpacingCtrlName.slice(4, 6);
    curValues = this.fCurManualVals.slice(4, 6);
    this.AddSpacingGroup(
      enumSpacingDiagram.mgrspacing,
      panelWidth,
      by,
      controlNames,
      curValues,
      kSpacingControlH,
      spacingControlW,
      "spacing",
      "adjboxsubs",
      false
    );
    by = by + 100;
    controlNames = enumSpacingCtrlName.slice(6, 10);
    curValues = this.fCurManualVals.slice(6, 10);
    //if (gShowSpacing)
    this.AddSpacingGroup(
      enumSpacingDiagram.spacing,
      panelWidth,
      by,
      controlNames,
      curValues,
      kSpacingControlH,
      spacingControlW,
      "spacing",
      "adjboxspace",
      true
    );

    yLoc = panelHeight - (plus10H + margin);
    xLoc = panelWidth - (plus10H + margin);
    this.fFastPlus = AddPlus10Control(xLoc, yLoc, true, "inc10", "toggleplus10", this);
    this.fFastPlus.SetIsToggleButton(true);
    this.fFastPlus.SetToggleState(this.fAdder != 1);

    var resetW = 54;
    var resetH = 21;
    AddStdButton(this, xLoc - resetW - 4, yLoc, resetW, resetH, appstr("Reset"), "resetspacing");
  }

  SpacingIndexFromCode(theCode) {
    var done = false;
    var i = 0;
    while (!done) {
      if (theCode == enumSpacingCtrlName[i]) done = true;
      else {
        i++;
        if (i >= enumSpacingCtrlName.length) return -1;
      }
    }

    return i;
  }

  AdjustPlacement(x, y, pickerWidth, pickerHeight) {
    var wsMgr = this.fWSMgr;
    var backGroundPanel = wsMgr.GetBackgroundPanel();

    var pickerRight = x + pickerWidth;
    var canvasWidth = backGroundPanel.fWidth;
    if (pickerRight > canvasWidth) x = x - (pickerRight - canvasWidth) - 4;

    var pickerBottom = y + pickerHeight;
    var canvasHeight = backGroundPanel.GetPositionY() + backGroundPanel.fHeight;
    if (pickerBottom > canvasHeight) y = y - (pickerBottom - canvasHeight) - 4;

    var p = new QPoint();
    p.InitPoint(x, y);

    return p;
  }

  HandleUserInputSpacing(theCode, curS, srcControl) {
    var height = this.GetHeight();
    var xPos = this.GetPositionX();
    var yPos = this.GetPositionY() + height + 6;
    var theWidth = this.GetWidth();

    var pickerPos = this.AdjustPlacement(xPos, yPos, theWidth, kSIHeight);
    var d = new QInputSpacingDialog();
    d.fUIColors = this.fUIColors;
    var w = this.fWSMgr;
    d.InitSpacingDialog(w, srcControl, this, theWidth, curS, theCode);
    d.PositionPanel(pickerPos.fX, pickerPos.fY);
    w.PushPanel(d);
    d.BecomeKeyboardTarget();
  }

  ExitSpacer(wsMgr) {
    this.SetTargetPanelRenderState(false);
    wsMgr.RemovePanel(this);
  }

  ExecuteCommand(aCmd) {
    var cmdCode = aCmd.GetCmdCode();
    var panelHandled = true;
    var wsMgr = aCmd.GetWSMgr();

    switch (cmdCode) {
      case "automaticspacing":
        this.fSpacingMode = kStandardMargins;
        this.ChangeMode();
        aCmd["spacingmode"] = kStandardMargins;
        break;
      case "densespacing":
        this.fSpacingMode = kDenseMargins;
        this.ChangeMode();
        aCmd["spacingmode"] = kDenseMargins;
        break;
      case "manualspacing":
      case "resetspacing":
        this.fSpacingMode = kManualMargins;
        this.fCurManualVals = GetDefaultManualSpacing().slice(0);
        this.ChangeMode();
        aCmd["spacingmode"] = kManualMargins;
        break;
      case "toggleplus10":
        if (this.fAdder == 10) this.fAdder = 1;
        else this.fAdder = 10;
        var nc = this.fAdjCtrls.length;
        for (var i = 0; i < nc; i++) this.fAdjCtrls[i].SetAdder(this.fAdder);
        break;
      case "CNCL":
        this.ExitSpacer(wsMgr);
        //wsMgr.RemovePanel(this);
        break;
      default:
        panelHandled = false;
        break;
    }

    if (panelHandled || cmdCode == "0000") return panelHandled;

    panelHandled = true;
    var codes = cmdCode.split("_");
    var startCode = codes[0];
    var endCode = codes[1];

    var adder = this.fAdder;
    var i = this.SpacingIndexFromCode(startCode);
    if (i == -1) return;

    var activeCtrl = this.fAdjCtrls[i];
    var curSpacing = activeCtrl.GetValue();

    switch (endCode) {
      case "sync":
        aCmd[startCode] = curSpacing;
        break;
      case "plus":
        curSpacing = curSpacing + adder;
        aCmd[startCode] = curSpacing;
        break;
      case "minus":
        curSpacing = curSpacing - adder;
        aCmd[startCode] = curSpacing;
        break;
      case "reset":
        curSpacing = kVertBoxSpacing;
        aCmd[startCode] = curSpacing;
        break;
      case "reset0":
        curSpacing = 0;
        aCmd[startCode] = curSpacing;
        break;
      case "enter":
        this.HandleUserInputSpacing(startCode, curSpacing, activeCtrl);
        panelHandled = false;
        break;
      default:
        panelHandled = false;
        break;
    }

    if (panelHandled) {
      activeCtrl.SetValue(curSpacing);
    }

    return panelHandled;
  }

  DoHandleRightClick(hitElement, x, y) {
    if (hitElement == null) return;

    var eType = hitElement.GetElementType();
    if (eType == kSpacingAdjElementType) {
      this.fRightClickCtrl = hitElement["parentctrl"];
      var w = this.fWSMgr;
      var s = new QSARightClick();
      s.InitMenu("SARightClick", w, x, y);
      w.PushPanel(s);
    }
  }

  HandleRightClickCmd(cmdCode, aCmd) {
    var panelHandled = false;

    switch (cmdCode) {
      case "RCResetSpacing":
        var resetCmd = this.fRightClickCtrl.GetResetCmd();
        aCmd.ChangeCmdCode(resetCmd);
        aCmd.fSourcePanel = this;
        this.fWSMgr.ExecuteCommand(aCmd);
        break;
    }

    return panelHandled;
  }

  AddSpacingControl(x, y, startVal, minusCmd, plusCmd, controlType, resetCmd, entercmd) {
    var spaceMax = kMaxVSpacing;
    var sC = AddSpacingControl(
      x,
      y,
      startVal,
      minusCmd,
      plusCmd,
      controlType,
      resetCmd,
      entercmd,
      this.fAdder,
      this,
      0,
      spaceMax,
      this.fUIColors
    );
    sC.fTextColor = this.fTextColor;
    return sC;

    /*
	var sC = new QSpacingControl();
	sC.fMinus = PAddZoomControl(x,y-2,false,null, minusCmd, this,true);

	x += 20;
	var sT = new QSpacingText();
	sT.InitSpacingText(startVal);
	sT.PositionElement(x,y);
	sT.SizeElement(30,12);
	this.PushElement(sT);
	sT.SetCmdCode(entercmd);
	sC.fValueText = sT;
	sT.SetElementType(kSpacingAdjElementType);
	sT["parentctrl"] = sC;
	sC.fResetCmd = resetCmd;

	x += 33;
	sC.fPlus = PAddZoomControl(x,y-2,true,null, plusCmd, this,true);

	sC.SetAdder(this.fAdder);
	sC.EnableControls();

	return sC;
	*/
  }
}
